import "@/App.css";
import { ReactLenis } from "lenis/react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarqueeBand from "@/components/MarqueeBand";
import Manifesto from "@/components/Manifesto";
import MenuSection from "@/components/MenuSection";
import Services from "@/components/Services";
import Reviews from "@/components/Reviews";
import Contacts from "@/components/Contacts";
import Footer from "@/components/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 1 }}>
      <div className="bg-ink text-cream font-body min-h-screen antialiased overflow-x-clip">
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <MarqueeBand />
          <Manifesto />
          <MenuSection />
          <Services />
          <Reviews />
          <Contacts />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}

export default App;
